import React from 'react';

const MissionVision = () => {
  const items = [
    {
      icon: "🎯",
      title: "Our Mission",
      description: "To provide comprehensive psychological support, advocacy, and resources to individuals affected by violence, fostering resilience and promoting long-term recovery through trauma-informed care, counseling, and community engagement."
    },
    {
      icon: "👁️",
      title: "Our Vision",
      description: "To create a world where survivors of violence are empowered to heal, rebuild their lives, and live with dignity, free from the scars of trauma."
    }
  ];

  return (
    <section className="mission-vision" id="about">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Foundation</h2>
          <p className="section-subtitle">Building a better future through compassion and empowerment</p>
        </div>
        <div className="cards-grid">
          {items.map((item, index) => (
            <div className={`card ${index === 0 ? 'card-mission' : 'card-vision'}`} key={index}>
              <div className="card-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionVision;
